<template>
  <div>
    <!-- 私募记录表 -->
    <div class="common-box margin-t10">
      <el-row class="row-one">
        <span class="row-one-title">{{'“'+$route.query.name+'”'}}</span>
        <span class="row-one-subTitle"> — 私募成交量记录表</span>
        <!-- <Reback class="row-one-fr" @click.native="$router.go(-1)"></Reback> -->
      </el-row>
      <!-- 筛选 -->
      <el-form class="form-single-inline" :inline="true" :model="formInlieOne" style="margin-top: 28px;">
        <el-form-item>
          <el-date-picker v-model="formInlieOne.datevalue1" type="date" placeholder="选择日期" @change="dateOneChange" :picker-options="pickerOptions">
          </el-date-picker>
          至
          <el-date-picker v-model="formInlieOne.datevalue2" type="date" placeholder="选择日期" @change="dateTwoChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="search" @click="search">查询 <i class="el-icon-search"></i></el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="loading" element-loading-text="加载中..." :data="tableOne" class="table-single margin-t20">
        <el-table-column label="基金名称" prop="fundName"></el-table-column>
        <el-table-column label="基金代码" prop="fundCode"></el-table-column>
        <el-table-column label="交易时间" prop="dealDate"></el-table-column>
        <el-table-column label="交易金额(元)" prop="moneyAmount"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="pagination-single" @current-change="handleCurrentChange" :current-page.sync="page" :page-size="pageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
  </div>

</template>

<script>
export default {
  name: 'privateSalesDetails',
  data () {
    var vm = this;
    return {
      tableOne: [],
      formInlieOne: {
        datevalue1: '',
        datevalue2: '',
      },
      loading: true,
      page: 1,
      pageNum: 10,
      total: 0,
      // 日期选择范围
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < new Date(vm.formInlieOne.datevalue1).getTime() - 3600 * 1000 * 24;
        },
      },
    }
  },
  created () {
    this.formInlieOne.datevalue1 = this.$route.query.time
    this.formInlieOne.datevalue2 = this.$commonJs.timeFormat(new Date()).substring(0, 10)
  },
  mounted () {
    this.getPrivateDetails()
  },
  methods: {
    // 开始日期
    dateOneChange (val) {
      this.formInlieOne.datevalue1 = this.$commonJs.timeFormat(val).substring(0, 10)
    },
    // 结束日期
    dateTwoChange (val) {
      this.formInlieOne.datevalue2 = this.$commonJs.timeFormat(val).substring(0, 10)
    },
    search () {
      this.loading = true
      this.getPrivateDetails()
    },
    handleCurrentChange (newPage) {
      this.page = newPage
      this.loading = true
      this.getPrivateDetails()
    },
    handleSizeChange (newSize) {
      this.pageNum = newSize
      this.loading = true
      this.getPrivateDetails()
    },
    // 成交量记录表
    getPrivateDetails () {
      this.$http.post(this.$apiPath.getCustPFSalesStatistics, {
        AdviserCode: this.$commonJs.getCookie('code'),
        Custno: this.$route.query.custon,
        StartDate: this.formInlieOne.datevalue1 ? this.formInlieOne.datevalue1 : '',
        EndDate: this.formInlieOne.datevalue2 ? this.formInlieOne.datevalue2 : '',
        page: this.page,
        pageNum: this.pageNum,
      }).then(res => {
        // console.log(res);
        this.loading = false
        if (res.data.code == 200) {
          this.tableOne = res.data.data.list
          this.total = res.data.data.recordCount
        }
      }).catch(err => { })
    },

  }
}
</script>

<style lang="less" scoped>
</style>